import React from 'react';
import { Form } from 'antd';
import { CargoItemInputFields } from 'components/common/cargo-item-input-fields';
import { ContainerCargoItemInputFields } from 'components/common/container-cargo-item-input-fields';
import type { ICargoItemEditFormProps } from './types';

export const CargoItemEditForm: React.FC<ICargoItemEditFormProps> = (props) => {
  const { form, formId, initialValues, onFinish, isContainer } = props;

  return (
    <Form form={form} id={formId} layout='vertical' initialValues={initialValues} onFinish={onFinish}>
      {isContainer ? (
        <ContainerCargoItemInputFields form={form} />
      ) : (
        <CargoItemInputFields form={form} withoutCount isStackRequired />
      )}
    </Form>
  );
};
